export const LEGACY_CRYPTO_CONTRACT = Object.freeze({
  indexedDb: 'summerintensiv-private-v1',
  objectStore: 'keys',
  vaultKeyPrefix: 'vault:',
  recoveryKdf: 'PBKDF2-SHA256',
  recoveryIterations: 600000,
  contentCipher: 'AES-GCM',
  identityAad: 'summer-identity-key-v1',
  journalAad: 'summer-journal-v1',
  messageAad: 'summer-message-v1',
  messageFileAad: 'summer-message-file-v1',
});

async function databaseExists(name: string): Promise<boolean> {
  if (!('databases' in indexedDB) || typeof indexedDB.databases !== 'function') return true;
  const databases = await indexedDB.databases();
  return databases.some(database => database.name === name);
}

export async function hasLocalVault(participantId: string): Promise<boolean> {
  if (!(await databaseExists(LEGACY_CRYPTO_CONTRACT.indexedDb))) return false;

  return new Promise(resolve => {
    let settled = false;
    const finish = (value: boolean) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };
    const request = indexedDB.open(LEGACY_CRYPTO_CONTRACT.indexedDb);
    request.onerror = () => finish(false);
    request.onupgradeneeded = () => {
      request.transaction?.abort();
      finish(false);
    };
    request.onsuccess = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(LEGACY_CRYPTO_CONTRACT.objectStore)) {
        db.close();
        finish(false);
        return;
      }
      try {
        const tx = db.transaction(LEGACY_CRYPTO_CONTRACT.objectStore, 'readonly');
        const get = tx.objectStore(LEGACY_CRYPTO_CONTRACT.objectStore).get(`${LEGACY_CRYPTO_CONTRACT.vaultKeyPrefix}${participantId}`);
        get.onsuccess = () => finish(Boolean(get.result));
        get.onerror = () => finish(false);
        tx.oncomplete = () => db.close();
        tx.onerror = () => { db.close(); finish(false); };
      } catch {
        db.close();
        finish(false);
      }
    };
  });
}
